module.exports = __webpack_public_path__ + "trello-logo.png";